import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { BundleInterface, setEditId, setEditError, selectBundleById } from "src/store/watcher/bundlesSlice";
import { updateBundle, fetchBundle } from "src/actions/watcher/bundlesActions";
import { objToFormData } from "src/helpers/FormHelper";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.watcher.bundles.editId);
  const error   = useAppSelector(state => state.watcher.bundles.editError);
  const bundle  = useAppSelector(state => selectBundleById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchBundle(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: BundleInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: BundleInterface) {
    const formData = objToFormData(data);
    const resultAction = await dispatch(updateBundle({ id, data: formData }));

    if (updateBundle.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-bundle'>
        <h6 className="v-content-label">Edit Bundle</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={bundle} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
